import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const HubSettingsNavigation: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HubSettingsNavigation" */ './HubSettingsNavigation.tsx'
			)
		).HubSettingsNavigation,
	name: 'HubSettingsNavigation',
});
